<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">{{title}}</span>
    </navbar>
    <div class="page-content">
      <!-- <scroller ref="scroller"> -->
      <div class="article-wrapper">
        <h3 class="text-center">{{article.title}}</h3>
        <div class="article-type text-right">
          <span>{{article.addDate}}</span>
        </div>
        <div class="article-txt" v-html="article.content">
        </div>
      </div>
      <!-- </scroller> -->
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  // import Scroller from 'components/scroller/scroller'
  export default {
    data () {
      return {
        article: {},
        articleId: null,
        title: '',
        articleType: null,
        pageNumber: 6
      }
    },
    created () {
      this.articleId = this.$route.params.id
      this.articleType = /culture/g.test(this.$route.fullPath) ? 2 : 1
      this.title = this.articleType === 2 ? '企业文化' : '案例分享'
      this.getCultureArticles()
    },
    // mounted () {
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       this.$refs.scroller.resize()
    //     }, 500)
    //   })
    // },
    methods: {
      getCultureArticles () {
        let vm = this
        this.$ajax({
          url: '/getArticleInfo.jhtml',
          params: {
            type: vm.articleType,
            articleId: vm.articleId
          },
          done (result) {
            vm.article = result
          }
        })
      }
    },
    components: {
      Navbar
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'
  .page-content
    overflow auto
  .article-wrapper
    margin px2rem(28) 1em px2rem(35)
    background-color #fff
    border-radius px2rem(10)
    box-shadow 0 px2rem(10) px2rem(30) 0 rgba(188, 200, 209, 1)
    padding px2rem(34) px2rem(30) px2rem(28) px2rem(30)
    h3
      margin 0
      color #275482
      font-size px2rem(26)
      line-height px2rem(50)
    .article-type
      font-size px2rem(20)
      color #97a1aa
      margin px2rem(13) 0 px2rem(11) 0
      width 100%
      line-height px2rem(50)
    .article-txt
      margin-top px2rem(30px)
      font-size px2rem(20)
      color #1a4369
      text-indent 2em
      line-height px2rem(40)
      letter-spacing px2rem(3)
      img
        display block!important

  /*p
    margin 0*/
</style>



// WEBPACK FOOTER //
// article.vue?707dfa1a